import { Box, Container, Stack, alpha } from "@mui/material";
import { Suspense, useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";

import ImpersonationBanner from "@/components/ImpersonationBanner";
import PageSkeleton from "@/components/Loading/PageSkeleton";
import Header from "@/layout/Header";
import AppNavbar from "@/layout/Header/AppNavbar";
import PageTitle from "@/layout/PageTitle";
import Sidebar from "@/layout/Sidebar";

const Layout = () => {
  const { pathname } = useLocation();
  const mainRef = useRef<HTMLElement>(null);

  // main is the scroller, so a new page would otherwise open at the old scroll offset.
  useEffect(() => {
    mainRef.current?.scrollTo({ top: 0 });
    window.scrollTo({ top: 0 });
  }, [pathname]);

  return (
    <Box sx={{ display: "flex" }}>
      <PageTitle />
      <Sidebar />
      <AppNavbar />
      <Box
        component="main"
        ref={mainRef}
        sx={(theme) => ({
          flexGrow: 1,
          backgroundColor: alpha(theme.palette.background.default, 1),
          overflow: "auto",
          // On desktop the page scrolls inside main, which lets the header stick to its top.
          height: { md: "100dvh" },
        })}
      >
        <Stack
          spacing={2}
          sx={{
            alignItems: "center",
            mx: 3,
            pb: 5,
            mt: { xs: 8, md: 0 },
          }}
        >
          <Header />
          <ImpersonationBanner />
          <Container maxWidth={false} disableGutters sx={{ width: "100%", maxWidth: 2200 }}>
            <Suspense fallback={<PageSkeleton />}>
              <Outlet />
            </Suspense>
          </Container>
        </Stack>
      </Box>
    </Box>
  );
};

export default Layout;
